import image1 from '../images/1.png';
import image2 from '../images/2.png';
import image3 from '../images/3.png';
import image4 from '../images/4.png';
import image5 from '../images/5.png';
import image6 from '../images/6.png';
import image7 from '../images/7.png';

export const Service_list = [
	{
		id: 1,
		title: 'Washing Machine Repairs',
		desc: 'Is your washing machine not spinning, leaking, or showing error codes? We repair all types – front load, top load, semi-automatic, & fully automatic machines.',
		img: image1,
	},
	{
		id: 2,
		title: 'Refrigerator Repair Services',
		desc: 'A faulty refrigerator can disrupt your daily life. We offer same-day refrigerator repairs for single-door, double-door, and side-by-side fridges.',
		img: image2,
	},
	{
		id: 3,
		title: 'Air Conditioner (AC) Repairs',
		desc: 'Beat Bangalore & Dhanbad’s heat with our expert AC repair services. Whether it’s split AC or window AC, we ensure efficient cooling and smooth performance.',
		img: image3,
	},
	{
		id: 4,
		title: 'Microwave Oven Repairs',
		desc: 'Don’t let a faulty microwave disrupt your kitchen routine. We repair solo, grill, and convection microwaves efficiently. Our technicians can fix it quickly and safely.',
		img: image4,
	},
	{
		id: 5,
		title: 'TV Repairs',
		desc: 'Facing issues with your TV? Whether it’s an LED, LCD, or Plasma TV, we provide expert repairs to resolve display, sound, or connectivity problems promptly.',
		img: image5,
	},
	{
		id: 6,
		title: 'Cooler Repairs',
		desc: 'Keep cool during the summer with our reliable cooler repair services. From desert coolers to personal coolers, we fix leaks, motor issues, and more.',
		img: image6,
	},
	{
		id: 7,
		title: 'Dish Washer Repairs',
		desc: 'Don’t let a faulty dishwasher pile up your chores. We repair dishwashers of all brands, tackling drainage issues, motor problems, and cleaning performance for hassle-free use.',
		img: image7,
	},
];
